import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { PaginationModel } from '../models/pagination-model';


@Injectable({ providedIn: 'root' })
export class TarjetaService {


    private readonly apiUrl = environment.apiEndpoint + 'tarjeta';

    constructor(private http: HttpClient) { }


    getTarjetas(idCliente: any, pageNum: number, pageSize: number, palabraClave: string): Observable<PaginationModel> {
        let finalurl = this.apiUrl + '/cliente/' + idCliente + '?pageNum=' + pageNum + '&pageSize=' + pageSize + '&palabraClave=' + palabraClave
        return this.http.get<PaginationModel>(finalurl, { withCredentials: true });
    }

    getTarjetasByTipo(idCliente: any, pageNum: number, pageSize: number, palabraClave: string, idTipoTarjeta?: number, excludeIdTipoTarjeta?: number): Observable<PaginationModel> {
        let finalurl = this.apiUrl + '/cliente/' + idCliente + '?pageNum=' + pageNum + '&pageSize=' + pageSize + '&palabraClave=' + palabraClave;
        if (idTipoTarjeta) finalurl += '&idTipoTarjeta=' + idTipoTarjeta;
        if (excludeIdTipoTarjeta) finalurl += '&excludeIdTipoTarjeta=' + excludeIdTipoTarjeta;
        return this.http.get<PaginationModel>(finalurl, { withCredentials: true });
    }

    getTarjetaById(idTarjeta: number): Observable<any> {
        return this.http.get<any>(this.apiUrl + '/' + idTarjeta, { withCredentials: true });
    }

    getTarjetaByUser(): Observable<any> {
        return this.http.get<any>(this.apiUrl + '/user', { withCredentials: true });
    }

    getTarjetasByUser(): Observable<any[]> {
        return this.http.get<any[]>(this.apiUrl + '/user/list', { withCredentials: true });
    }

    getTarjetasByUserTipo(idTipoTarjeta: number): Observable<any[]> {
        return this.http.get<any[]>(this.apiUrl + '/user/list/tipo/' + idTipoTarjeta, { withCredentials: true });
    }

    getTarjetaByCode(codigo: any): Observable<any> {
        return this.http.get<any>(this.apiUrl + '/codigo/' + codigo, { withCredentials: true });
    }

    getFichaMotorDocumentoTipos(): Observable<any[]> {
        return this.http.get<any[]>(this.apiUrl + '/ficha-motor/documentos/tipos', { withCredentials: true });
    }

    createFichaMotor(data: FormData): Observable<any> {
        return this.http.post(this.apiUrl + '/ficha-motor', data);
    }

    updateFichaMotor(idTarjeta: number | string, data: FormData): Observable<any> {
        return this.http.put(this.apiUrl + '/ficha-motor/' + idTarjeta, data);
    }

    updateTarjeta(tarjetaData: FormData): Observable<any> {
        return this.http.put(this.apiUrl, tarjetaData);
    }

    createTarjeta(tarjetaData: FormData): Observable<any> {
        return this.http.post(this.apiUrl, tarjetaData);
    }

    updateCroaBilledStatus(id: number | string, status: boolean): Observable<any> {
        const url = `${environment.apiEndpoint}tarjeta/${id}/update-croa-billed-status`;
        return this.http.put<any>(url, { croaBilled: status });
    }

    getMasterCardInfo(idCliente: number | string): Observable<any> {
        const url = `${environment.apiEndpoint}tarjeta/master-card-info/${idCliente}`;
        return this.http.get<any>(url, { withCredentials: true });
    }

    sendConsulta(uid: any, formulario: any): Observable<any> {
        let finalurl = this.apiUrl + '/codigo/contacto/' + uid
        return this.http.post(finalurl, formulario);
    }

    deleteTarjeta(id: number): Observable<any> {
        return this.http.delete(this.apiUrl + '/' + id, { withCredentials: true });
    }

    getTopTarjetas(pageNum: number, pageSize: number, palabraClave: string, idCliente: number | null): Observable<any> {
        return this.http.get<any>(this.apiUrl + '/getTopTarjetas?pageNum=' + pageNum + '&pageSize=' + pageSize + '&palabraClave=' + palabraClave + '&idCliente=' + idCliente, { withCredentials: true });
    }

    getPaginTopTarjetas(pageNum: number, pageSize: number, palabraClave: string): Observable<any> {
        return this.http.get<any>(this.apiUrl + '/getPaginTopTarjetas?pageNum=' + pageNum + '&pageSize=' + pageSize + '&palabraClave=' + palabraClave, { withCredentials: true });
    }


    getGoogleWalletByCode(codigo: any): Observable<string> {
        return this.http.get<string>(environment.apiEndpoint + 'wallet/google/' + codigo, { responseType: 'text' as 'json' });
    }
}
